<template>
  <c-col col="6">
    <c-card>
      <loading v-show="loading" />
      <c-card-header>
        <c-card-title>
          <strong>Kategori Asset</strong>
        </c-card-title>
      </c-card-header>
      <c-card-body>
        <div v-show="isEdit">
          <div class="form-group form-row">
            <label class="col-form-label col-sm-3">Code</label>
            <div class="col-sm-9">
              <input
                type="text"
                class="form-control"
                v-bind:class="{'has-error': errors.code}"
                v-model="code.code"
                placeholder="Asset Code"
              />
            </div>
          </div>
          <div class="form-group form-row">
            <label class="col-form-label col-sm-3">Name</label>
            <div class="col-sm-9">
              <input
                type="text"
                class="form-control"
                v-bind:class="{'has-error': errors.name}"
                v-model="code.name"
                placeholder="Name"
              />
            </div>
          </div>
          <div class="form-group form-row">
            <label class="col-form-label col-sm-3">Description</label>
            <div class="col-sm-9">
              <input
                type="text"
                class="form-control"
                v-bind:class="{'has-error': errors.description}"
                v-model="code.description"
                placeholder="Description"
              />
            </div>
          </div>
        </div>
        <div v-show="!isEdit">
          <table class="table table-bordered">
            <thead>
              <tr>
                <th>Code</th>
                <th>Name</th>
                <th>Description</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(d, k) in codes.data" :key="k" v-bind:class="{'header': (d.code.substr(9,2) === '00')}">
                <td>{{d.code}}</td>
                <td>{{d.name}}</td>
                <td>{{d.description}}</td>
                <td align="center">
                  <button class="btn-outline-warning btn btn-action" @click="doEdit(d)">
                    <i class="cil-pencil"></i>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </c-card-body>
      <c-card-footer>
        <div v-show="isEdit">
          <button v-show="code.id" class="btn btn-success" @click="edit">
            <i class="cil-save"></i> Simpan
          </button>
          <button v-show="!code.id" class="btn btn-success" @click="save">
            <i class="cil-save"></i> Simpan
          </button>
        </div>
        <button v-show="!isEdit" class="btn btn-primary" @click="isEdit = true">
          <i class="cil-plus"></i> Tambah
        </button>
      </c-card-footer>
    </c-card>
  </c-col>
</template>
<script>
import Loading from "../../components/Loading";
import { HTTPAUTH } from "../../lib/httplib";
export default {
  name: "AssetCode",
  data() {
    return {
      codes: [],
      code: {},
      errors: [],
      isEdit: false,
      loading: false
    };
  },
  components: {
    Loading
  },
  created() {
    this.list();
  },
  methods: {
    list() {
      this.loading = true;
      HTTPAUTH.get("/api/v1/asset-code")
        .then(res => {
          this.codes = res.data;
          this.loading = false;
        })
        .catch(eres => {
          this.loading = false;
        });
    },
    doEdit(d) {
      this.code = d;
      this.isEdit = true;
    },
    edit() {
      HTTPAUTH.put("/api/v1/asset-code/" + this.code.id, this.code)
        .then(res => {
          this.isEdit = false;
          this.code = {};
          this.$toasted.success("Data berhasil diubah").goAway();
        })
        .catch(eres => {
          this.loading = false;
          if (eres.response.data.message) {
            this.$toasted.error(eres.response.data.message).goAway(3000);
            this.errors = eres.response.data.errors;
            return;
          }
          this.$toasted.error(eres.response.data.user_message).goAway(3000);
        });
    },
    save() {
      HTTPAUTH.post("/api/v1/asset-code", this.code)
        .then(res => {
          this.isEdit = false;
          this.code = {};
          this.$toasted.success("Data berhasil ditambahkan").goAway();
        })
        .catch(eres => {
          this.loading = false;
          if (eres.response.data.message) {
            this.$toasted.error(eres.response.data.message).goAway(3000);
            this.errors = eres.response.data.errors;
            return;
          }
          this.$toasted.error(eres.response.data.user_message).goAway(3000);
        });
    }
  }
};
</script>